export const SELECT_SUBMENU_ID = 'select-submenu';
